export interface spinnerState {
  readonly isOpen: boolean;
  readonly ongoingRequests: number;
}

export const SPINNER_TOGGLE_ON = 'SPINNER_TOGGLE_ON';
export const SPINNER_TOGGLE_OFF = 'SPINNER_TOGGLE_OFF';